import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CheckList, ThirdPartyNotice, CtaBand } from "../components/site/blocks";
import { COMPANY, IMAGES } from "../data/site";

const VALUES = [
  { t: "Respect", d: "De la personne, de son rythme, de ses choix et de son intimité. Le logement est un lieu de vie avant d'être un chantier." },
  { t: "Exactitude", d: "Nous appliquons les règles officielles des aides et l'écrivons clairement. Nos estimations sont indicatives et le disent." },
  { t: "Indépendance", d: "Habitalys n'exécute pas de travaux et n'est rémunérée par aucune entreprise. Notre conseil n'a qu'un objectif : votre intérêt." },
  { t: "Engagement", d: "Un interlocuteur unique, des réponses sous 48 h ouvrées, des comptes rendus écrits à chaque étape." },
];

export default function APropos() {
  useSeo("À propos d'Habitalys", "Habitalys, SAS basée à Fresnes (94) : conseil et AMO indépendants pour l'adaptation, la sécurisation et la rénovation des logements. Nous n'exécutons pas les travaux.");
  return (
    <>
      <PageHero eyebrow="À propos" title="Habitalys, le conseil indépendant au service de l'habitat"
        intro="Habitalys est une société de conseil et d'assistance à maîtrise d'ouvrage fondée en 2026 à Fresnes, dans le Val-de-Marne. Notre mission : aider chacun à vivre dans un logement adapté, sûr et confortable, en rendant accessibles les aides et l'expertise qui le permettent."
        image={IMAGES.advisor} imageAlt="Conseillère échangeant avec un couple de seniors dans leur cuisine" />
      <Section eyebrow="Notre raison d'être" title="Pourquoi Habitalys ?">
        <div className="grid lg:grid-cols-2 gap-12">
          <div className="prose-h text-lg">
            <p>Le vieillissement de la population et l'urgence énergétique transforment notre rapport au logement. Les dispositifs publics existent, mais leur complexité décourage souvent ceux qui en ont le plus besoin : personnes âgées, personnes en situation de handicap, aidants déjà très sollicités.</p>
            <p>Habitalys a été créée pour combler ce fossé : une structure de conseil qui conjugue compréhension des besoins humains, connaissance du bâti et maîtrise des démarches. Notre activité relève des métiers de l'économie de la construction : nous analysons, estimons, programmons et contrôlons.</p>
          </div>
          <ThirdPartyNotice />
        </div>
      </Section>
      <Section tone="mist" eyebrow="Nos valeurs" title="Ce qui nous engage">
        <div className="grid sm:grid-cols-2 gap-6">
          {VALUES.map((v) => <div key={v.t} className="rounded-2xl bg-white border border-navy/10 p-7"><h3 className="text-2xl">{v.t}</h3><p className="mt-3 text-slate-700">{v.d}</p></div>)}
        </div>
      </Section>
      <Section eyebrow="Notre engagement d'indépendance" title="Conseiller sans exécuter">
        <div className="grid lg:grid-cols-2 gap-12">
          <CheckList items={[
            "Les travaux sont réalisés par des entreprises tierces qualifiées et assurées, contractant directement avec le maître d'ouvrage.",
            "Nous vérifions les assurances et les qualifications des entreprises consultées.",
            "Nous ne percevons aucune commission sur les travaux.",
            "Nous ne revendiquons aucune certification ou habilitation que nous ne détenons pas : lorsqu'un dispositif impose un opérateur habilité ou agréé, nous vous l'indiquons.",
          ]} />
          <div className="card-soft" data-testid="about-company-facts">
            <h3 className="text-2xl">Identité de l'entreprise</h3>
            <dl className="mt-5 grid grid-cols-[auto,1fr] gap-x-6 gap-y-3 text-slate-700">
              <dt className="font-semibold text-navy">Forme</dt><dd>{COMPANY.form}</dd>
              <dt className="font-semibold text-navy">Siège</dt><dd>{COMPANY.street}, {COMPANY.city}</dd>
              <dt className="font-semibold text-navy">SIREN</dt><dd>{COMPANY.siren}</dd>
              <dt className="font-semibold text-navy">Activité</dt><dd>{COMPANY.naf}</dd>
              <dt className="font-semibold text-navy">Président</dt><dd>{COMPANY.president}</dd>
              <dt className="font-semibold text-navy">Création</dt><dd>{COMPANY.created}</dd>
            </dl>
          </div>
        </div>
      </Section>
      <CtaBand />
    </>
  );
}
